import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import {
  APPLY_QUEUE_TABLE_FILTERS,
  CLEAR_APPLIED_QUEUE_TABLE_FILTERS,
  CLEAR_QUEUE_TABLE_FILTERS,
  FETCH_CALL_HANDLING_SUCCESS,
  FETCH_QUEUE_WAIT_TIME_SUCCESS,
  SELECTED_QUEUE_VIEW,
  SET_QUEUES_DETAILS,
  SET_QUEUE_INFO,
  SET_QUEUE_TABLE_FILTERS
} from "../actions/queueMonitorActions";

const intitialState = {
  callHandlingAggregate: {},
  callHandlingHourlyData: {},
  queueWaitTimeAggregate: [],
  allQueuesDetails: [],
  queueInfoObj: {},
  queueMonitorTableFilters: {
    selectedQueueOptions: [],
    selectedQueue: [],
  },
  appliedFiltersSelections: {},
  selectedQueueDetails: {},
};
const getKeyName = () => {
  return process.env.REACT_APP_VERSION + "-QueueMonitor";
};

export const queueMonitorReducer = persistReducer(
  {
    storage,
    key: getKeyName(),
    whitelist: ["callHandlingAggregate"],
  },
  (state = intitialState, action) => {
    switch (action.type) {
      case FETCH_CALL_HANDLING_SUCCESS: {
        if (action.payload && action.payload.status === 200) {
          const { data } = { ...action.payload.success };
          const { aggregated_data, hourly_data } = { ...data };
          var newState = {
            ...state,
            callHandlingAggregate: {
              ...state.callHandlingAggregate,
              [action.payload.queue_id]: { ...aggregated_data },
            },
            callHandlingHourlyData: {
              ...state.callHandlingHourlyData,
              [action.payload.queue_id]: { ...hourly_data },
            },
          };
        }
        return newState;
      }

      case FETCH_QUEUE_WAIT_TIME_SUCCESS: {
        if (action.payload) {
          const { waits_data } = { ...action.payload.details };
          const { objects } = { ...waits_data };
          var newQueueWaitTimeState = {
            ...state,
            queueWaitTimeAggregate: objects,
          };
        }
        return newQueueWaitTimeState;
      }

      case SET_QUEUES_DETAILS: {
        if (action.payload) {
          var queueDetailsNewState = {
            ...state,
            allQueuesDetails: action.payload,
          };
        }
        return queueDetailsNewState;
      }
      case SET_QUEUE_INFO: {
        if (action.payload) {
          var queueInfoNewSate = {
            ...state,
            queueInfoObj: {
              ...state.queueInfoObj,
              ...action.payload,
            },
          };
        }
        return queueInfoNewSate;
      }

      case SELECTED_QUEUE_VIEW: {
        if (action.payload) {
          var queueDetailed = {
            ...state,
            selectedQueueDetails: {
              ...action.payload,
            },
          };
        }
        return queueDetailed;
      }

      case SET_QUEUE_TABLE_FILTERS: {
        if (action.payload) {
          var setFilters = {
            ...state,
            queueMonitorTableFilters: {
              ...state.queueMonitorTableFilters,
              ...action.payload["changelog"],
            },
          };
        }
        return setFilters;
      }

      case CLEAR_QUEUE_TABLE_FILTERS: {
        let changelog = {};
        changelog.selectedSolutions = [];
        changelog.selectedSolutionOptions = [];
        changelog.selectedQueue = [];
        changelog.selectedQueueOptions = [];
        var clearFilters = {
          ...state,
          queueMonitorTableFilters: {
            ...state.queueMonitorTableFilters,
            ...changelog,
          },
        };
        return clearFilters;
      }

      case APPLY_QUEUE_TABLE_FILTERS: {
        if (action.payload["changelog"]) {
          var applyFilters = {
            ...state,
            appliedFiltersSelections: {
              ...state.appliedFiltersSelections,
              queue_name: action.payload["changelog"]["selectedQueue"],
            },
          };
          return applyFilters;
        }
        return state;
      }

      case CLEAR_APPLIED_QUEUE_TABLE_FILTERS: {
        var newClearedState = { ...state.appliedFiltersSelections };
        Object.keys(newClearedState).map((key) => {
          newClearedState[key] = [];
        });
        var clearAppliedFilters = {
          ...state,
          appliedFiltersSelections: {
            ...newClearedState,
          },
        };
        return clearAppliedFilters;
      }

      case actionTypes.Logout: {
        return intitialState;
      }
      default: {
        return state;
      }
    }
  }
);
